import { FC, useEffect, useRef, useState } from 'react'
import {
    Link
} from "react-router-dom";
import Breadcrumb from '../../Components/Breadcrumb';


import { Formik, Field, Form, FormikProps } from 'formik'
import * as yup from 'yup'; 

import SpentType from "../../Models/SpentType"

import DataTable from 'react-data-table-component';

import Alert from '../../Components/Alert';
import { useAppDispatch, useAppSelector } from '../../Hooks/customSelector';


// type FormValues = Gamme;

//Alert
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import SpentService from './service';
import { useTranslation } from 'react-i18next';

const SpentTypePage: FC = () => {  

    // const alert = useAppSelector((state: RootState ) => state.alerts );
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    const formRef = useRef< FormikProps<SpentType>>(null);

    const [
        loading, setLoading
    ] = useState(false);

    const [
        types,
        setTypes
    ] = useState([]);

    const initialSelectedGamme: any = null

    const [
        selectedType,
        setSelectedType
    ] = useState(initialSelectedGamme);

    const [
        deleteLoading, setDeleteLoading
    ] = useState(false);

   const id: Number = 0;
    const [
        deleteId, setDeleteId
    ] = useState(id);


    const spentService = new SpentService();

    const deleteSpentType = async (salaryId: Number) => {
        setDeleteId(salaryId);
        setDeleteLoading(true);

        confirmAlert({
            overlayClassName: "alert-overlay",
            customUI: ({ onClose }) => {
              return (
                    <Alert 
                        alert={{
                            title: t('Confirmer'),
                            message: t('Vous confirmez la suppression de ce type ?'),
                            actionText: `${t('Valider')}`,
                            action: async () => {
                                await spentService.deleteSpentType(salaryId).then(async function (response: any) {
                                    console.log(response); 
                                   
                                    getSpentTypes();
                                    setDeleteLoading(false); 

                                    confirmAlert({
                                        overlayClassName: "alert-overlay",
                                        customUI: ({ onClose }) => {
                                          return (
                                                <Alert 
                                                    alert={{
                                                        title: 'Succès',
                                                        message: 'Type de dépense supprimé avec succès',
                                                        actionText: 'Ok',
                                                        action: () => {
                                                            onClose();
                                                        }
                                                    }}
                                                />
                                          );
                                        }
                                    });

                                })
                                  .catch(function (error: any) {
                                    console.log(error);
                                    setDeleteLoading(false); 
                                });
                                onClose();
                            },
                            cancelText: `${t('Annuler')}`,
                            cancelAction: () => {
                                setDeleteLoading(false); 
                                onClose();
                            }
                        }}
                    />
              );
            }
        });

    }

    const getSpentTypes = () => {
        setLoading(true);
        spentService.getSpentTypes().then(async function (response: any) {
            console.log(response); 
            setTypes(response.data);
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }

    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id
        },
        {
            name: t('Libellé'),
            selector: (row: any) => row.libDepense,
        },
        {
            name: t('Description'),
            selector: (row: any) => row.descDepense,
        }, 
        {
            name: "Options", 
            selector: (row: any) => (
                <div className='btn-list'>
                    {/* <button type="button" onClick={event => {
                        setSelectedType(SpentType.fromJson(row) );
                        if ( formRef.current != null) {
                            formRef.current.values.id = row.id;
                            formRef.current.values.libelleDep =  row.libelleDep;
                            formRef.current.values.descDep = row.descDep;
                        }  
                    }}
                        className="btn waves-effect waves-light btn-success">
                            <span className="" style={{ fontSize: "1em" }} >
                                <i className="icon-pencil"></i></span>
                    </button> */}
                    <button type="button" onClick={event => {  deleteSpentType(row.id)  }}
                        className="btn waves-effect waves-light btn-danger">
                            {
                                deleteId == row.id && deleteLoading ?
                                <div className="spinner-border text-light spinner-border-sm" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div> :
                                <span className="" style={{ fontSize: "1em" }} >
                                <i className="icon-trash"></i></span>
                            }
                    </button>
                </div>
            )
        }
    ];


    const cancel = () => {

        setSelectedType(null);

        if ( formRef.current != null) {
            formRef.current.values.id = null;
            formRef.current.values.libelleDep =  '';
            formRef.current.values.descDep = '';
        } 
    }

    useEffect(() => {
        getSpentTypes();
    }, []);



    return ( 
        <>  
            <Breadcrumb />

            <div className="container-fluid">

                <div className="row">
                    <div className="col-md-5">
                        <div className="card">
                            <div className="card-body">

                                <h4 className="card-title">
                                    {
                                        selectedType == null ? 
                                        t("Ajouter un type") :
                                        t("Mettre à jour type")
                                    }
                                </h4>

                                <Formik
                                    initialValues={
                                        {
                                        id: null,
                                        libelleDep: '',
                                        descDep: ''
                                    }}
                                    validationSchema={
                                        yup.object().shape({
                                            libelleDep: yup
                                                .string() 
                                                .required(`${t('Ce champ est obligatoire')}`),
                                            descDep: yup
                                                .string()
                                        })
                                    }
                                    onSubmit={async (
                                        values 
                                    ) => {

                                        setLoading(true);

                                        if(selectedType == null) {

                                            await spentService.postSpentType( SpentType.fromJson(values) ).then(async function (response: any) {
                                                console.log(response);

                                                confirmAlert({
                                                    overlayClassName: "alert-overlay",
                                                    customUI: ({ onClose }) => {
                                                      return (
                                                            <Alert 
                                                                alert={{
                                                                    title: t('Succès'),
                                                                    message: t('Type dépense créé avec succès'),
                                                                    actionText: 'Ok',
                                                                    action: () => {
                                                                        onClose();
                                                                    }
                                                                }}
                                                            />
                                                      );
                                                    }
                                                });
 
                                                if ( formRef.current != null) {
                                                    formRef.current.values.id = null;
                                                    formRef.current.values.libelleDep =  '';
                                                    formRef.current.values.descDep = '';
                                                } 
                                                getSpentTypes();
                                                setLoading(false); 
                                            })
                                            .catch(function (error: any) {
                                                setLoading(false); 
                                            });

                                        }  else {

                                            await spentService.putSalaryType( SpentType.fromJson(values) ).then(async function (response: any) {
                                                console.log(response); 
                                                confirmAlert({
                                                    overlayClassName: "alert-overlay",
                                                    customUI: ({ onClose }) => {
                                                      return (
                                                            <Alert 
                                                                alert={{
                                                                    title: t('Succès'),
                                                                    message: t('Gamme mis à jour avec succès'),
                                                                    actionText: 'Ok',
                                                                    action: () => {
                                                                        onClose();
                                                                    }
                                                                }}
                                                            />
                                                      );
                                                    }
                                                }); 

                                                if ( formRef.current != null) {
                                                    formRef.current.values.id = null;
                                                    formRef.current.values.libelleDep =  '';
                                                    formRef.current.values.descDep = '';
                                                } 

                                                setSelectedType(null);

                                                getSpentTypes();
                                                setLoading(false); 
                                            })
                                            .catch(function (error: any) {
                                                setLoading(false); 
                                            });

                                        }

                                        
          
                                    }} 
                                    innerRef={formRef}
                                    >
                                        {({ dirty, errors, touched, isValid, handleChange, handleBlur, handleSubmit, values }) => (
                                                    <Form>
                                                        <div className="form-body">
                                                            
                                                            <div className="row">
                                                                
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label>
                                                                            { t('Libellé') } </label>
                                                                        <input type="text"
                                                                            className={`form-control ${ errors.libelleDep && touched.libelleDep ? "is-invalid":""}`}
                                                                            id="libelleDep" 
                                                                            name="libelleDep" 
                                                                            onChange={handleChange('libelleDep')}
                                                                            onBlur={handleBlur('libelleDep')}
                                                                            value={values.libelleDep}
                                                                            placeholder={ t('Libellé') ?? '' } />
                                                                        { errors.libelleDep && touched.libelleDep && errors.libelleDep && 
                                                                        <div id="validationServer05Feedback" className="invalid-feedback">
                                                                            { errors.libelleDep && touched.libelleDep && errors.libelleDep }
                                                                        </div> }
                                                                    </div>
                                                                </div>
                                                            </div> 

                                                            
                                                            <div className="row">
                                                                
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label> {t('Description')} </label>
                                                                        <textarea rows={6}
                                                                            className={`form-control ${ errors.descDep
                                                                                 && touched.descDep ? "is-invalid":""}`}
                                                                            id="descDep" 
                                                                            name="descDep" 
                                                                            onChange={handleChange('descDep')}
                                                                            onBlur={handleBlur('descDep')}
                                                                            value={values.descDep}
                                                                            placeholder={t('Description') ?? ''}  />
                                                                        { errors.descDep && touched.descDep && errors.descDep && 
                                                                        <div id="validationServer05Feedback" className="invalid-feedback">
                                                                            { errors.descDep && touched.descDep && errors.descDep }
                                                                        </div> }
                                                                    </div>
                                                                </div>
                                                            </div> 

                                                        </div>

                                                        <div className="form-actions">
                                                            <div className="text-right">
                                                                <button  disabled={!isValid} type="submit" className="btn btn-info">
                                                                    { t('Valider') }
                                                                    {
                                                                        loading && <div className="spinner-border text-light spinner-border-sm" role="status">
                                                                            <span className="sr-only">Loading...</span>
                                                                        </div>
                                                                    }
                                                                </button>
                                                                <button type="button" onClick={event => cancel()}
                                                                 className="btn btn-dark">
                                                                    { t('Annuler') }
                                                                 </button>
                                                            </div>
                                                        </div>

                                                    </Form>
                                              )}
                                    </Formik>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">
                                    { t('Liste types dépense') }
                                </h4>
                                <div className="btn-list">
                                    <button type="button" onClick={ event => getSpentTypes() }
                                        className="btn waves-effect waves-light btn-success">
                                            { t('Actualiser') }
                                        </button>
                                </div> 
                                <div className="table-responsive">
                                    <DataTable
                                        responsive={true}
                                        className="table table-striped table-bordered"
                                        columns={columns}
                                        data={types}
                                        progressPending={loading}
                                        pagination
                                    />
                                </div>
                             </div>
                        </div> 
                    </div> 
                </div>

            </div>   
        </>                   
    );
}

export default SpentTypePage